import axios from "axios";
import {
  getStoredToken,
  isTokenExpired,
  clearAuthAndRedirectToLogin,
} from "../utils/auth";

const WABA_API_BASE = process.env.REACT_APP_WABA_SERVER_URL;

const qrAPI = axios.create({
  baseURL: `${WABA_API_BASE}/api/qr-codes`,
  headers: { "Content-Type": "application/json" },
});

qrAPI.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (!token || isTokenExpired(token)) {
    clearAuthAndRedirectToLogin();
    return Promise.reject(new Error("Token expired"));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

qrAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirectToLogin();
    }
    return Promise.reject(error);
  }
);

export const listQrCodes = (phoneId) => qrAPI.get(`/${phoneId}`);

export const createQrCode = (phoneId, payload) => qrAPI.post(`/${phoneId}`, payload);

export const updateQrCode = (phoneId, payload) => qrAPI.patch(`/${phoneId}`, payload);
